/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5 drivers · ${i?.constructors}/2 constructors`)
};

const es_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5 pilotos · ${i?.constructors}/2 constructores`)
};

const de_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5 Fahrer · ${i?.constructors}/2 Konstrukteure`)
};

const nl_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5 coureurs · ${i?.constructors}/2 constructeurs`)
};

const fr_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5 pilotes · ${i?.constructors}/2 constructeurs`)
};

const it_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5 piloti · ${i?.constructors}/2 costruttori`)
};

const pt_br2_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5 pilotos · ${i?.constructors}/2 construtores`)
};

const pt_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5 pilotos · ${i?.constructors}/2 construtores`)
};

const ja_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5ドライバー · ${i?.constructors}/2コンストラクター`)
};

const zh_f1_team_selector_summary = /** @type {(inputs: { drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.drivers}/5车手 · ${i?.constructors}/2车队`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ drivers: NonNullable<unknown>, constructors: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_team_selector_summary = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_team_selector_summary(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_team_selector_summary", locale)
	if (locale === "en") return en_f1_team_selector_summary(inputs)
	if (locale === "es") return es_f1_team_selector_summary(inputs)
	if (locale === "de") return de_f1_team_selector_summary(inputs)
	if (locale === "nl") return nl_f1_team_selector_summary(inputs)
	if (locale === "fr") return fr_f1_team_selector_summary(inputs)
	if (locale === "it") return it_f1_team_selector_summary(inputs)
	if (locale === "pt-BR") return pt_br2_f1_team_selector_summary(inputs)
	if (locale === "pt") return pt_f1_team_selector_summary(inputs)
	if (locale === "ja") return ja_f1_team_selector_summary(inputs)
	return zh_f1_team_selector_summary(inputs)
};